import React, { useState, useEffect } from "react";
import API_URL from "../config";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import { useApiFetch } from "../utils/apiFetch";

function EliminarTecnicos() {
    const { tecnicoSeleccionado, setModuloActual, setSubModuloActual, logout } = useGlobal();
    const [idTecnico, setIdTecnico] = useState("");
    const [datosTecnico, setDatosTecnico] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const apiFetch = useApiFetch();

    // Mecánica, Si viene desde ConsultarTecnicos.jsx y ya hay tecnicoSeleccionado va a cargar directo
    useEffect(() => {
        if (tecnicoSeleccionado) {
            const cargarTecnico = async () => {
                try {
                    const data = await apiFetch("consulta_9.php", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id_tecnico: tecnicoSeleccionado })
                    }, logout);

                    if (data.status === "ok" && data.tecnico) {
                        setDatosTecnico(data.tecnico);
                    } else {
                        setError(data.message || "Técnico no encontrado.");
                    }
                } catch {
                    setError("Error al cargar técnico.");
                }
            };

            cargarTecnico();
        }
    }, [tecnicoSeleccionado]);

    // Si se va a buscar el técnico manualmente (no viene de ConsultarTecnicos.jsx)
    const handleBuscar = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);

        try {

            const data = await apiFetch("consulta_9.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_tecnico: idTecnico })
            }, logout);

            if (data.status === "ok" && data.tecnico) {
                setDatosTecnico(data.tecnico);
            } else {
                setError(data.message || "Técnico no encontrado.");
            }
        } catch {
            setError("Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    // Eliminar técnico
    const handleEliminar = async () => {
        setError("");
        setSuccess("");
        setLoading(true);

        try {

            const data = await apiFetch("eliminar_tecnicos.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_tecnico: tecnicoSeleccionado || idTecnico })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Técnico eliminado correctamente.");
            } else {
                setError(data.message || "Error al eliminar técnico.");
            }

            setTimeout(() => {
                setModuloActual("Control");
                setSubModuloActual(null);
                setLoading(false);
            }, 3000);

        } catch {
            setError("Error de conexión con el servidor.");
            setTimeout(() => {
                setModuloActual("Control");
                setSubModuloActual(null);
                setLoading(false);
            }, 3000);
        }
    };

    // Cancelar y volver a la vista anterior
    const handleCancelar = () => {
        // Limpia estados
        setDatosTecnico(null);
        setIdTecnico("");
        setError("");
        setSuccess("");

        // Regresa al módulo anterior
        setModuloActual("Control");
        setSubModuloActual("Consultar Técnicos");
    };

    return (
        <div className="sesion-form">
            {/* Mostrar formulario inicial solo si no hay tecnicoSeleccionado */}
            {!datosTecnico && !tecnicoSeleccionado && (
                <form onSubmit={handleBuscar}>

                    <InputGenerico
                        value={idTecnico}
                        setValue={setIdTecnico}
                        label="Número de empleado"
                        maxLength={7}
                        allowedChars="0-9"
                        placeholder="7120000"
                        title="Debe contener exactamente 7 dígitos numéricos"
                    />

                    {error && <div className="error">{error}</div>}
                    {success && <div className="success">{success}</div>}

                    <div className="form-buttons">
                        <button type="submit" disabled={loading}>
                            {loading ? "Buscando..." : "Buscar"}
                        </button>
                    </div>
                </form>
            )}

            {datosTecnico && (
                <div>
                    <p>
                        ¿Seguro que deseas eliminar al: <strong>{datosTecnico.nombre_rol} {datosTecnico.id_tecnico}</strong><br></br>
                        Nombre: <strong>{datosTecnico.usuario} {datosTecnico.a_paterno} {datosTecnico.a_materno}</strong><br></br>
                        Estado: <strong>{datosTecnico.nombre_estado}</strong>?
                    </p>
                    {error && <div className="error">{error}</div>}
                    {success && <div className="success">{success}</div>}

                    <div className="form-buttons">
                        <button onClick={handleEliminar} disabled={loading}>
                            {loading ? "Eliminando..." : "Eliminar"}
                        </button>
                        <button onClick={handleCancelar}>
                            Cancelar
                        </button>
                    </div>

                </div>
            )}
        </div>
    );
}

export default EliminarTecnicos;